import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Chip, Grid2, Typography, Snackbar, Alert } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import { ImageWithFallback } from "./section-components/product";
import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { getWishlist } from "../services/wishlistService";
import { Pageheader } from "./global-components/page-header";
import bgImg from '../assets/img/newimgaes/Lettings Main Photo.jpeg';
import Toast from "../components/Toast"

export const WhishlistPage = (props) => {
    const user = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

    const [properties, setProperties] = useState({});
    const [toastMessage, setToastMessage] = useState('');
    const [toastOpen, setToastOpen] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);  

    useEffect(() => {
        if (user && user._id && !hasFetched) {  
            console.log(user, 'user');
            setHasFetched(true); 

            getWishlist(user._id)
                .then((res) => {
                    console.log(res, 'res');
                    setProperties(res);
                    // setToastMessage("Wishlist loaded successfully!");
                    // setToastOpen(true);
                })
                .catch((err) => {
                    console.error(err);
                    setToastMessage("Failed to load wishlist. Please try again.");
                    setToastOpen(true);
                });
        } else {
            console.error("No user data found in sessionStorage.");
        }
    }, [user, hasFetched]);

    return (
        <>
            <Pageheader headertitle="Whishlist" isSlider bgImage={bgImg} />
            {properties?.wishlist?.length > 0 ? (
                properties.wishlist.map((el) => (
                    <Card sx={{ boxShadow: 3, borderRadius: 2, cursor: "pointer" }} key={el._id}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ lg: 6, md: 6 }}>
                                <Box sx={{ position: "relative" }}>
                                    <Carousel showThumbs={false} infiniteLoop showStatus={false} autoPlay>
                                        {el.images?.length > 0 &&
                                            el.images.map((image, index) => (
                                                <ImageWithFallback key={index} src={image} alt={`Property ${index + 1}`} />
                                            ))}
                                    </Carousel>
                                    <Chip
                                        label={el.propertyStatus}
                                        sx={{
                                            position: "absolute",
                                            top: 16,
                                            left: 16,
                                            backgroundColor: "#d8b035",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            paddingX: 1.5,
                                        }}
                                    />
                                </Box>
                            </Grid2>
                            <Grid2 size={{ lg: 6, md: 6 }}>
                                <CardContent>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Chip
                                            label={el.type}
                                            size="small"
                                            sx={{
                                                backgroundColor: "#f0f4ff",
                                                color: "#d8b035",
                                                fontWeight: "bold",
                                                marginBottom: 1,
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="h6" color="primary" sx={{ fontWeight: "bold", color: "#d8b035" }}>
                                        {/* &#x20b9;{el.rentOrPrice} */}
                                        {el.country === "United Kingdom" ? "£" : "₹"}{el.price || el.rentOrPrice}
                                    </Typography>
                                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: 0.5 }}>
                                        {el.name}
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "center", marginTop: 1, color: "#666" }}>
                                        <LocationOnIcon fontSize="small" sx={{ color: "#d8b035" }} />
                                        <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                                            {el.location}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 2 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                                            <CropSquareIcon fontSize="small" sx={{ color: "#d8b035" }} />
                                            <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                                                {el.landSize}
                                            </Typography>
                                        </Box>
                                        {el.type !== 'Office' && (
                                            <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                                                <BedIcon fontSize="small" sx={{ color: "#d8b035" }} />
                                                <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                                                    {el.bedrooms}
                                                </Typography>
                                            </Box>
                                        )}
                                        <Box sx={{ display: "flex", alignItems: "center", color: "#666" }}>
                                            <BathtubIcon fontSize="small" sx={{ color: "#d8b035" }} />
                                            <Typography variant="body2" sx={{ marginLeft: 0.5 }}>
                                                {el.bathroom} Bath
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography component={'h3'} sx={{ marginTop: '10px' }}>
                                            Features
                                        </Typography>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontWeight: "bold",
                                                color: "#6c757d",
                                                marginBottom: 1,
                                            }}
                                            dangerouslySetInnerHTML={{ __html: el.features }}
                                        />
                                    </Box>
                                </CardContent>
                            </Grid2>
                        </Grid2>
                    </Card>
                ))
            ) : (
                <Typography variant="h6" sx={{ padding: 2 }}>
                    No properties found in your wishlist.
                </Typography>
            )}

            <Toast
                open={toastOpen}
                message={toastMessage}
                severity="error"
                onClose={() => setToastOpen(false)}
            />
        </>
    );
};
